import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

import { AuthComponent } from "@core/auth/auth.component";
import { HomeComponent } from "@core/components/home/home.component";
import { AuthGuard } from "@core/auth/auth.guard";
import { NotFoundComponent } from "@core/components/not-found/not-found.component";
import { LogInGuard } from "@core/auth/log-in.guard";
import { MobileVoteComponent } from "@core/components/mobile-vote/mobile-vote.component";
import { MobileVoteGuard } from "@core/guards/mobile-vote.guard";
import { VotingPermitGuard } from "@core/guards/voting-permit.guard";
import { ExtensionComponent } from "@core/components/extension/extension.component";
import { ExtensionAuthGuard } from "@core/auth/extension.auth.guard";
import { DeviceGuard } from "./core/guards/device.guard";
import { MainLayoutComponent } from "./components/main-layout/main-layout.component";
import { DashboardComponent } from "./components/dashboard/dashboard.component";
import { MobileLayoutComponent } from "./components/mobile-layout/mobile-layout.component";
import { ChatbotComponent } from "./core/components/chatbot/chatbot.component";
import { PipelineComponent } from "./components/pipeline/pipeline.component";
import { CompanyDetailsV2Component } from "./components/company-details-v2/company-details-v2.component";
import { InteractionsComponent } from "./components/interactions/interactions.component";
import { PortfolioUpdateV2Component } from "./components/portfolio-update-v2/portfolio-update-v2.component";
import { ElevationComponent } from "./components/elevation/elevation.component";
import { MonthlyCalendarComponent } from "./core/components/monthly-calendar/monthly-calendar.component";
import { IcComponent } from "./components/ic/ic.component";
import { AdminPanelComponent } from "./components/adminpanel/admin-panel.component";
import { PromptComponent } from "@core/components/prompt-component/prompt.component";
import { ExtensionV2Component } from "./components/extension-v2/extension-v2.component";
import { ElevationReportComponent } from "./components/elevation-report/elevation-report.component";
import { InteractionsReviewComponent } from "./components/interactions-review/interactions-review.component";

const routes: Routes = [
  {
    path: "login",
    component: AuthComponent,
    canActivate: [LogInGuard],
  },
  {
    path: "login/sso",
    component: AuthComponent,
    canActivate: [LogInGuard],
  },
  { path: "extension", component: ExtensionComponent, canActivate: [ExtensionAuthGuard, MobileVoteGuard] },
  { path: "extension-new", component: ExtensionV2Component, canActivate: [ExtensionAuthGuard, MobileVoteGuard] },
  { path: "extension/prompt", component: PromptComponent, canActivate: [ExtensionAuthGuard, MobileVoteGuard] },
  {
    path: "",
    component: MainLayoutComponent,
    canActivate: [AuthGuard, DeviceGuard],
    children: [
      { path: "", component: PipelineComponent, canActivate: [AuthGuard, MobileVoteGuard] },
      { path: "company/:id", component: PipelineComponent, canActivate: [AuthGuard, MobileVoteGuard] },
      { path: "companies", component: PipelineComponent, canActivate: [AuthGuard, MobileVoteGuard] },
      //{ path: "companies/details/:id", component: CompanyDetailsV2Component, canActivate: [AuthGuard, MobileVoteGuard] },
      { path: "companies/interactions", component: InteractionsComponent, canActivate: [AuthGuard, MobileVoteGuard] },
      { path: "companies/interactions/review", component: InteractionsReviewComponent, canActivate: [AuthGuard, MobileVoteGuard] },
      { path: "travel", component: MonthlyCalendarComponent, canActivate: [AuthGuard, MobileVoteGuard] },
      { path: "elevations", component: ElevationComponent, canActivate: [AuthGuard, MobileVoteGuard] },
      { path: "elevations/auto", component: ElevationComponent, canActivate: [AuthGuard, MobileVoteGuard] },
      { path: "elevations/all", component: ElevationComponent, canActivate: [AuthGuard, MobileVoteGuard] },
      { path: "elevations/my", component: ElevationComponent, canActivate: [AuthGuard, MobileVoteGuard] },
      { path: "elevations/report", component: ElevationReportComponent, canActivate: [AuthGuard, MobileVoteGuard] },
      { path: "dashboard", component: DashboardComponent, canActivate: [AuthGuard, MobileVoteGuard] },
      { path: "weekly-update", component: PortfolioUpdateV2Component, canActivate: [AuthGuard, MobileVoteGuard] },
      { path: "ic", component: IcComponent, canActivate: [AuthGuard, MobileVoteGuard] },
      { path: "ic/history", component: IcComponent, canActivate: [AuthGuard, MobileVoteGuard] },
      { path: "ic/combined", component: IcComponent, canActivate: [AuthGuard, MobileVoteGuard] },
      { path: "chatbot", component: ChatbotComponent, canActivate: [AuthGuard, MobileVoteGuard] },
      { path: "prompts", component: PromptComponent, canActivate: [AuthGuard, MobileVoteGuard] },
      { path: "admin-panel", component: AdminPanelComponent, canActivate: [AuthGuard, MobileVoteGuard] },
      { path: "admin-panel/alert", component: AdminPanelComponent, canActivate: [AuthGuard, MobileVoteGuard] },
    ],
  },
  {
    path: "m",
    component: MobileLayoutComponent,
    canActivate: [AuthGuard, DeviceGuard],
    children: [
      { path: "travel", component: MonthlyCalendarComponent, canActivate: [AuthGuard, MobileVoteGuard] },
      { path: "companies", component: PipelineComponent, canActivate: [AuthGuard, MobileVoteGuard] },
      { path: "elevation", component: ElevationComponent, canActivate: [AuthGuard, MobileVoteGuard] },
      { path: "elevations", component: ElevationComponent, canActivate: [AuthGuard, MobileVoteGuard] },
      { path: "elevations/auto", component: ElevationComponent, canActivate: [AuthGuard, MobileVoteGuard] },
      { path: "elevations/all", component: ElevationComponent, canActivate: [AuthGuard, MobileVoteGuard] },
      { path: "elevations/my", component: ElevationComponent, canActivate: [AuthGuard, MobileVoteGuard] },
      {
        path: "companies/details/:id",
        component: CompanyDetailsV2Component,
        canActivate: [AuthGuard, MobileVoteGuard],
      },
      { path: "companies/interactions", component: InteractionsComponent, canActivate: [AuthGuard, MobileVoteGuard] },
      { path: "chatbot", component: ChatbotComponent, canActivate: [AuthGuard, MobileVoteGuard] },
      { path: "weekly-update", component: PortfolioUpdateV2Component, canActivate: [AuthGuard, MobileVoteGuard] },
      { path: "ic", component: IcComponent, canActivate: [AuthGuard, MobileVoteGuard] },
      { path: "ic/history", component: IcComponent, canActivate: [AuthGuard, MobileVoteGuard] },
      { path: "ic/combined", component: IcComponent, canActivate: [AuthGuard, MobileVoteGuard] },
      { path: "dashboard", component: DashboardComponent, canActivate: [AuthGuard, MobileVoteGuard] },
      // Wildcard route to handle unknown paths under /m
      { path: "**", redirectTo: "companies", pathMatch: "full" },
    ],
  },
  { path: "**", component: NotFoundComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: "reload" })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
